<div class="carousel-bg"
  [ngClass]="{'carousel-bg--open': open}"
  (click)="close()"
></div>

@if (open) {
  <button class="button button--white carousel-close"
    (click)="close()"
    >
    <i class="fa-solid fa-xmark"></i>
  </button>
}

<div class="carousel"
  [ngClass]="{'carousel--open': open}"
  (click)="$event.stopPropagation()"
  >
  <div class="carousel__control"
    (click)="prev()"
    [class.carousel__control--disabled]="index <= 0"
    >
    <i class="fa-solid fa-arrow-left"></i>
  </div>

  @if (currentImage && photos) {
    <div class="carousel__image">
      <p class="carousel__image-count">{{'carousel.count'|transloco: {'currentIndex': index + 1, 'total': photos.length} }}</p>
      <div #frame
        class="carousel__frame"
        (pointerdown)="onPointerDown($event)"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp($event)"
        (pointercancel)="onPointerUp($event)"
        (pointerleave)="onPointerUp($event)"
      >
        <div class="carousel__track"
          [class.carousel__track--dragging]="dragging"
          [style.transform]="trackTransform"
        >
          @for (photo of photos; track photo.id ?? photo.url ?? i; let i = $index) {
            <div class="carousel__slide">
              <app-image
                [src]="photo?.url ?? ''"
                [alt]="'Photo ' + (photo?.id ?? i + 1)"
                preset="hero"
                [sizes]="'(max-width: 768px) 100vw, 90vw'"
                [priority]="true"
                [fill]="true"
                [fit]="'contain'"
              ></app-image>
            </div>
          }
        </div>
      </div>
      <p class="carousel__image-name">#{{currentImage.id}}</p>
      <div class="carousel__mobile-controls">
        <div class="carousel__control"
          (click)="prev()"
          [class.carousel__control--disabled]="index <= 0"
          >
          <i class="fa-solid fa-arrow-left"></i>
        </div>
        <div class="carousel__control"
          (click)="next()"
          [class.carousel__control--disabled]="!photos || index >= (photos.length - 1)"
          >
          <i class="fa-solid fa-arrow-right"></i>
        </div>
      </div>
    </div>
  }

  <div class="carousel__control"
    (click)="next()"
    [class.carousel__control--disabled]="!photos || index >= (photos.length - 1)"
    >
    <i class="fa-solid fa-arrow-right"></i>
  </div>
</div>
